import PropTypes from "prop-types";
import { Label } from "../../../../../../components/Label/component";
import LinkWrap from "../../../../../../components/LinkWrap/component";
import * as pathUtils from "../../../../../../utils/path/library";
import { getSharedTitle } from "../../../../../../utils/dataTransform/utils";
import { EXTERNAL_LINK_TYPES } from "./constants";

/**
 * @param {Object} props The component props
 * @returns {React.Component} Returns the RelatedItem component
 */
export function RelatedItem({
    flag,
    external = false,
    type,
    url,
    shareHeadline,
    title,
}) {
    const sharedTitle = getSharedTitle({ shareHeadline, title });
    const isExternal = external || EXTERNAL_LINK_TYPES.includes(type);
    const relativeURL = pathUtils.removeUrlDomain(url);
    const relatedItemUrl = isExternal ? url : relativeURL;

    return (
        <li className="relatedListItem" data-testid="relatedListItem">
            <LinkWrap
                className="relatedLink"
                external={isExternal}
                url={relatedItemUrl}
            >
                <Label flag={flag || ""} external={isExternal} /> {sharedTitle}
            </LinkWrap>
        </li>
    );
}

RelatedItem.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    flag: PropTypes.string,
    external: PropTypes.bool,
};

export default RelatedItem;
